// pages/Blog.jsx (Original layout structure preserved)
import React, { useState, useEffect } from "react";
import BlogList from '../components/BlogList.jsx';
import CategoryButtons from "./components/CategoryButtons.jsx";
import styles from "../style.js";
import Footer from "../components/Footer.jsx";
import blogService from '../services/blogServices.js';
import { Reveal } from "../components/reveal.jsx";
import { Link, useNavigate } from 'react-router-dom';
import { FiArrowRight } from "react-icons/fi";
import { s10 } from "../assets/index.js";

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [blogs, setBlogs] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
const navigate = useNavigate();

  const categories = [
    'Education', 'Institutions'
  ];

  useEffect(() => {
  // Check authentication status
  const authStatus = localStorage.getItem('isAuthenticated') === 'true';
    setIsAuthenticated(authStatus);
  }, []);

  const handleAddBlog = () => {
    navigate('/BlogWrite');
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    // Load blogs
    loadBlogs();
    
    // Subscribe to blog updates
    const unsubscribe = blogService.addListener(() => {
      loadBlogs();
    });
    
    return () => {
      window.removeEventListener('resize', checkMobile);
      unsubscribe();
    };
  }, []);

  const loadBlogs = () => {
    setLoading(true);
    const publishedBlogs = blogService.getPublishedBlogs();
    setBlogs(publishedBlogs);
    setLoading(false);
  };

  // Filter blogs by selected category (similar to your pattern)
  const filteredBlogs = !selectedCategory 
    ? blogs 
    : blogs.filter(blog => blog.category === selectedCategory);
    
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
          <p className="mt-4 text-gray-600">Loading blogs...</p>
        </div>
      </div>
    );
  }

  return (
    <section className={`flex flex-col gap-10`}
    style={{ 
      backgroundImage: `url(${s10})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      transform: [{ scaleX: -1 }],
      zIndex: 0,
    }}
    >
      <div className="pt-80 pb-16 flex flex-col ga-10 items-center w-full">
        <div className="w-full flex flex-col md:flex-row md:gap-20 gap-10 items-start justify-center pt-20 px-10">
            <Reveal className="flex flex-col gap-4 items-start md:items-end py-40 pb-16">
                <h2 className="text-sm font-semibold">
                    News
                </h2>
                <h2 className="pt-4 xs:text-md text-md font-semibold max-w-[300px]">
                    Press &
                </h2>
                <h2 className="xs:text-md text-md font-semibold max-w-[300px] text-secondary">
                    News Articles
                </h2>
            </Reveal>     
    
            <Reveal className="flex flex-col items-start">
                <p className={`xs:text-mm text-sm font-semibold text-start max-w-[600px]`}>
                    Over the years, we've helped unlock opportunities for thousands. From expanding access to education, to improving livelihoods across communities.
                </p>
                <p className={`xs:text-sm text-ss text-start my-6 max-w-[600px]`}> 
                    This impact is only possible through shared effort and long-term collaboration. As we continue to grow, your involvement can help extend this reach and deepen the difference we make together.
                </p> 
                {isAuthenticated && (
                  <button
                    type="button"
                    onClick={handleAddBlog}
                    className="text-red-500 hover:text-red-700 py-10 flex flex-row items-center justify-center gap-2"
                  >
                    <div className="w-[40px] h-[40px] bg-second items-center justify-center flex  mr-2">
                        <FiArrowRight size={20} className="text-fourth" />
                    </div>
                    <h2 className="text-sm font-semibold">
                        Add Blog
                    </h2>
                  </button>
                )}
            </Reveal>
        </div>
      </div>  
      <div className={`sticky top-24 z-10 !important ${styles.flexCenter} flex-col gap-5`}>
        <div className="w-full overflow-x-auto overflow-y-hidden" style={{ msOverflowStyle: 'none', scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch'}}>
          <div className="flex flex-nowrap gap-2 px-4 py-2 h-[40px] items-center justify-center" style={{ minWidth: 'max-content' }}>
            <CategoryButtons
              categories={categories} 
              selectedCategory={selectedCategory}
              onSelectCategory={setSelectedCategory}
            />
          </div>
        </div>
      </div>
      <BlogList products={filteredBlogs}/>         
      <Footer />
    </section>
  );
};

export default Blog;